import { calculateEntryAmount } from '@/services/utils';
angular.module('leanlaw').controller('InvoiceBuilderCtrl', ['$scope', '$q', '$stateParams', '$state', 'userService', 'leanLawApi', 'invoiceFilterService', 'matterManager', 'clientManager', 'alerts', 'entriesManager', 'expenseManager', 'chargeManager', function ($scope, $q, $stateParams, $state, userService, leanLawApi, invoiceFilterService, matterManager, clientManager, alerts, entriesManager, expenseManager, chargeManager) {
  // View model
  $scope.vm = {
    loading: true,
    empty: true,
    filterState: invoiceFilterService.state,
    creating: false,
    selected: {
      billableEntries: false,
      nonBillableEntries: false,
      expenses: false,
      charges: false
    },
    totals: {
      matters: {},
      users: {},
      total: {}
    },
    billableEntries: [],
    nonBillableEntries: [],
    charges: [],
    expenses: [],
    client: undefined,
    matter: undefined
  };

  // Functions
  $scope.update = summarize;
  $scope.toggleGroup = toggleGroup;
  $scope.toggleItem = toggleItem;
  $scope.openEntry = openEntry;
  $scope.openExpense = openExpense;
  $scope.openCharge = openCharge;
  $scope.create = create;

  // Go
  alerts.dismiss();
  activate();

  // Function to generate comma-separated string of checked checkboxes
  function getCheckboxesChecked() {
    const checkedBoxes = [];

    // Check Billable Time (if any billable entries are selected)
    if ($scope.vm.selected.billableEntries && $scope.vm.billableEntries.some(entry => entry.selected)) {
      checkedBoxes.push('billable time');
    }

    // Check Non-Billable Time (if any non-billable entries are selected)
    if ($scope.vm.selected.nonBillableEntries && $scope.vm.nonBillableEntries.some(entry => entry.selected)) {
      checkedBoxes.push('non billable time');
    }

    // Check Expenses (if any expenses are selected)
    if ($scope.vm.selected.expenses && $scope.vm.expenses.some(expense => expense.selected)) {
      checkedBoxes.push('expenses');
    }

    // Check Fixed Fees (if any charges are selected)
    if ($scope.vm.selected.charges && $scope.vm.charges.some(charge => charge.selected)) {
      checkedBoxes.push('fixed fee');
    }
    return checkedBoxes.join(', ');
  }

  ////////////////////////////////////////

  let loadedState;
  async function activate() {
    $scope.me = await userService.me();
    const {
      settings
    } = $scope.me.company;
    $scope.customFlagLabel = settings.labels && settings.labels.customFlag;
    $scope.adjustments = $scope.me.adjustments;
    if ($stateParams.matterId) {
      $scope.vm.matter = await matterManager.get($stateParams.matterId);
      if (!$scope.vm.matter.access.billing) {
        $state.go('billing.invoice.staging');
        return;
      }
    } else if ($stateParams.clientId) {
      $scope.vm.client = await clientManager.get($stateParams.clientId, {
        matters: 'include',
        scope: 'involved'
      });
    }
    $scope.$watch('vm.filterState', () => {
      if (!invoiceFilterService.reload(loadedState)) return;
      loadedState = angular.copy(invoiceFilterService.state);
      if (!$scope.vm.matter && !$scope.vm.client) return;
      reload();
    }, true);
  }
  async function reload() {
    $scope.vm.loading = true;
    let loading = [];
    const query = invoiceFilterService.filterQuery();
    const expenseQuery = invoiceFilterService.expenseFilterQuery();
    if ($stateParams.matterId) {
      loading = [entriesManager.listForMatter($scope.vm.matter, query), chargeManager.listForMatter($scope.vm.matter.id, query), expenseManager.listForMatter($scope.vm.matter.id, expenseQuery)];
    } else if ($stateParams.clientId) {
      loading = [entriesManager.listForClient($scope.vm.client, query), chargeManager.listForClient($scope.vm.client.id, query), expenseManager.listForClient($scope.vm.client.id, expenseQuery)];
    }
    let entries;
    [entries, $scope.vm.charges, $scope.vm.expenses] = await $q.all(loading);
    $scope.vm.billableEntries = entries.filter(e => e.billingType === 'billable');
    $scope.vm.nonBillableEntries = entries.filter(e => e.billingType !== 'billable');
    $scope.vm.loading = false;
    updateSelections();
    summarize();
  }
  function updateSelections() {
    selectAll('billableEntries', true);
    selectAll('nonBillableEntries', false);
    selectAll('expenses', true);
    if ($scope.vm.charges.length) {
      // the request for charges include start and end date (optionally)
      // but for charges we don't want them to be included if the date
      // is later than today.
      $scope.vm.charges.forEach(charge => {
        if (charge.date) {
          // eslint-disable-next-line no-param-reassign
          charge.selected = new Date(charge.date) <= new Date();
        } else {
          // eslint-disable-next-line no-param-reassign
          charge.selected = true;
        }
      });
      $scope.vm.selected.charges = $scope.vm.charges.find(c => !c.selected) ? undefined : true;
    }
  }
  function selectAll(group) {
    const items = $scope.vm[group];
    $scope.vm.selected[group] = !!items.length;
    if (items.length) {
      items.forEach(e => {
        e.selected = true;
      });
    }
  }
  async function create() {
    const {
      billableEntries,
      nonBillableEntries,
      expenses,
      charges
    } = $scope.vm;
    const entries = billableEntries.concat(nonBillableEntries);
    const filter = invoiceFilterService.filterQuery();
    const request = {
      method: 'builder',
      filter: {
        clientId: $scope.vm.client ? $scope.vm.client.id : null,
        matterId: $scope.vm.matter ? $scope.vm.matter.id : null,
        startDate: filter.startDate,
        endDate: filter.endDate,
        timeOffset: new Date().getTimezoneOffset(),
        checkboxesChecked: getCheckboxesChecked()
      },
      items: {
        entries: selectedItemsWithIds(entries),
        expenses: selectedItemsWithIds(expenses),
        charges: selectedItemsWithIds(charges)
      }
    };
    if (invoiceFilterService.state.expenseRange) {
      // TODO maybe not necessary
      const expenseRequest = invoiceFilterService.expenseFilterQuery();
      request.filter.expenseRange = {
        startDate: expenseRequest.startDate,
        endDate: expenseRequest.endDate
      };
    }
    $scope.vm.creating = true;
    try {
      await leanLawApi.createInvoice({
        body: request
      });
      alerts.success('Successfully created draft invoice');
      $state.go('^');
    } catch (err) {
      alerts.error(err);
    } finally {
      $scope.vm.creating = false;
    }
  }
  function selectedItemsWithIds(items) {
    return items.filter(e => e.selected).map(e => ({
      id: e.id
    }));
  }
  function summarize() {
    const {
      billableEntries,
      nonBillableEntries,
      expenses,
      charges
    } = $scope.vm;
    const users = {};
    const matters = {};
    billableEntries.filter(e => e.selected).forEach(entry => {
      const user = getUser(users, entry.account);
      const amount = calculateEntryAmount(entry.rate.amount, entry.billedHours);
      user.billable += entry.billedHours;
      user.amount += amount;
      const matter = getMatter(matters, entry.matter);
      matter.entries += amount;
      matter.total += amount;
    });
    nonBillableEntries.filter(e => e.selected).forEach(entry => {
      const user = getUser(users, entry.account);
      user.nonBillable += entry.nonBillable;
    });
    expenses.filter(e => e.selected).forEach(expense => {
      const matter = getMatter(matters, expense.matter);
      matter.expenses += expense.amount;
      matter.total += expense.amount;
    });
    charges.filter(e => e.selected).forEach(charge => {
      const matter = getMatter(matters, charge.matter);
      matter.charges += charge.amount;
      matter.total += charge.amount;
    });
    $scope.vm.totals.users = Object.keys(users).map(id => users[id]);
    $scope.vm.totals.matters = Object.keys(matters).map(id => matters[id]);
    $scope.vm.totals.total = {
      entries: $scope.vm.totals.matters.reduce((sum, m) => sum + m.entries, 0),
      charges: $scope.vm.totals.matters.reduce((sum, m) => sum + m.charges, 0),
      expenses: $scope.vm.totals.matters.reduce((sum, m) => sum + m.expenses, 0),
      total: $scope.vm.totals.matters.reduce((sum, m) => sum + m.total, 0)
    };
    $scope.vm.empty = $scope.vm.totals.total.total === 0;
  }
  function getUser(users, user) {
    if (!user || !user.id) {
      return undefined;
    }
    if (users[user.id]) {
      return users[user.id];
    }
    const newUser = {
      user,
      billable: 0,
      nonBillable: 0,
      amount: 0
    };
    // eslint-disable-next-line no-param-reassign
    users[user.id] = newUser;
    return newUser;
  }
  function getMatter(matters, matter) {
    if (!matter || !matter.id) {
      return undefined;
    }
    if (matters[matter.id]) {
      return matters[matter.id];
    }
    const newMatter = {
      matter,
      entries: 0,
      expenses: 0,
      charges: 0,
      total: 0
    };
    // eslint-disable-next-line no-param-reassign
    matters[matter.id] = newMatter;
    return newMatter;
  }
  function toggleGroup(group) {
    $scope.vm[group].forEach(item => {
      // eslint-disable-next-line no-param-reassign
      item.selected = $scope.vm.selected[group];
    });
    summarize();
  }
  function toggleItem(group, item) {
    // eslint-disable-next-line no-param-reassign
    $scope.vm.selected[group] = undefined;
    summarize();
  }
  function openEntry(entry) {
    const {
      settings
    } = $scope.me;
    if (entry && entry.id) {
      // Use the new modal if available, otherwise fall back to the original route
      const enableNewTimeEntry = ($scope.me.features?.timeEntriesTab ?? false) && (settings?.enableNewTimeEntry ?? false);
      if (enableNewTimeEntry) {
        $state.go('billing.invoice.builder.entry2', {
          entryId: entry.id
        });
      } else {
        // Fallback to original entry editing route if new modal is not available
        $state.go('billing.invoice.builder.entry', {
          entryId: entry.id
        });
      }
    }
  }
  function openExpense() {}
  function openCharge() {}
}]);